module.exports = __webpack_public_path__ + "static/media/github.63de5479.png";